const EXPIRING_SOON_WINDOW_DAYS = 30;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

const startOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

/** True when expiryDate is today, in the past, or within 30 calendar days from today. */
export const isExpiringSoon = (expiryDate) => {
  if (!expiryDate) return false;
  const diffDays = (new Date(expiryDate) - startOfToday()) / MS_PER_DAY;
  return diffDays <= EXPIRING_SOON_WINDOW_DAYS;
};

/** True when expiryDate is today or in the future (not yet expired). */
export const isValid = (expiryDate) => {
  if (!expiryDate) return false;
  return new Date(expiryDate) >= startOfToday();
};

/** True when expiryDate is strictly in the past. */
export const isExpired = (expiryDate) => {
  if (!expiryDate) return false;
  return new Date(expiryDate) < startOfToday();
};

/** 'Expired' | 'Expiring Soon' | 'Valid', based on today vs. expiryDate. */
export const getCertificateStatus = (expiryDate) => {
  if (isExpired(expiryDate)) return 'Expired';
  if (isExpiringSoon(expiryDate)) return 'Expiring Soon';
  return 'Valid';
};

/** Whole days from today until expiryDate, or null once it has expired (no date is shown). */
export const getDaysUntilExpiry = (expiryDate) => {
  if (!expiryDate || isExpired(expiryDate)) return null;
  return Math.round((new Date(expiryDate) - startOfToday()) / MS_PER_DAY);
};

export const ALLOWED_CERTIFICATE_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx'];
export const MAX_CERTIFICATE_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const getFileExtension = (fileName = '') => {
  const parts = String(fileName).split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

export const isAllowedCertificateFile = (file) => {
  if (!file) return false;
  const extension = getFileExtension(file.name);
  return ALLOWED_CERTIFICATE_EXTENSIONS.includes(extension) && file.size <= MAX_CERTIFICATE_FILE_SIZE_BYTES;
};
